// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoteHeader-module__font-s-10___Q2f81 {
  font-size: 10px !important;
}

.NoteHeader-module__font-s-12___nMwLI {
  font-size: 12px !important;
}

.NoteHeader-module__font-s-13____LqSY {
  font-size: 13px !important;
}

.NoteHeader-module__font-s-14___Po4ji {
  font-size: 14px !important;
}

.NoteHeader-module__font-s-15___BGNUA {
  font-size: 15px !important;
}

.NoteHeader-module__font-s-16___hEJhj {
  font-size: 16px !important;
}

.NoteHeader-module__font-s-18___pbZIF {
  font-size: 18px !important;
}

.NoteHeader-module__font-s-20___KIPW5 {
  font-size: 20px !important;
}

.NoteHeader-module__font-s-22___FKJb1 {
  font-size: 22px !important;
}

.NoteHeader-module__font-s-28___er8Fr {
  font-size: 28px !important;
}

.NoteHeader-module__font-w-400___rJvxe {
  font-weight: 400 !important;
}

.NoteHeader-module__font-w-500___ZzzgL {
  font-weight: 500 !important;
}

.NoteHeader-module__font-w-600___gfcIL {
  font-weight: 600 !important;
}

.NoteHeader-module__font-w-700___JQuy1 {
  font-weight: 700 !important;
}

.NoteHeader-module__p-5___dU2JU {
  padding: 5px !important;
}

.NoteHeader-module__p-12___kkcf7 {
  padding: 12px !important;
}

.NoteHeader-module__p-16___lyAE0 {
  padding: 16px !important;
}

.NoteHeader-module__p-30___zBkDL {
  padding: 30px !important;
}

.NoteHeader-module__p-b-0___tK3FL {
  padding-bottom: 0 !important;
}

.NoteHeader-module__p-b-5____r90j {
  padding-bottom: 5px !important;
}

.NoteHeader-module__p-b-10___z4wXU {
  padding-bottom: 10px !important;
}

.NoteHeader-module__p-b-12___WytX4 {
  padding-bottom: 12px !important;
}

.NoteHeader-module__p-b-16___tb6sv {
  padding-bottom: 16px !important;
}

.NoteHeader-module__p-b-18___dUHsf {
  padding-bottom: 18px !important;
}

.NoteHeader-module__p-b-20___NiuQG {
  padding-bottom: 20px !important;
}

.NoteHeader-module__p-b-25___l754P {
  padding-bottom: 25px !important;
}

.NoteHeader-module__p-b-30___bHJ1i {
  padding-bottom: 30px !important;
}

.NoteHeader-module__p-b-50___o0Dov {
  padding-bottom: 50px !important;
}

.NoteHeader-module__p-t-0___vDlg8 {
  padding-top: 0 !important;
}

.NoteHeader-module__p-t-12___cULVN {
  padding-top: 12px !important;
}

.NoteHeader-module__p-t-16___mg36f {
  padding-top: 16px !important;
}

.NoteHeader-module__p-t-18___GakpD {
  padding-top: 18px !important;
}

.NoteHeader-module__p-t-20___Whfx0 {
  padding-top: 20px !important;
}

.NoteHeader-module__p-t-30___EfEij {
  padding-top: 30px !important;
}

.NoteHeader-module__p-t-40___G8D8G {
  padding-top: 40px !important;
}

.NoteHeader-module__p-t-50___PHg1P {
  padding-top: 50px !important;
}

.NoteHeader-module__p-l-20___QHYJ4 {
  padding-left: 20px !important;
}

.NoteHeader-module__p-l-30___ij2sJ {
  padding-left: 30px !important;
}

.NoteHeader-module__p-l-40___da_Pl {
  padding-left: 40px !important;
}

.NoteHeader-module__p-r-16___HHMQ8 {
  padding-right: 16px !important;
}

.NoteHeader-module__p-r-20___vBFAL {
  padding-right: 20px !important;
}

.NoteHeader-module__p-r-30___ZguBy {
  padding-right: 30px !important;
}

.NoteHeader-module__p-r-50___FLua3 {
  padding-right: 50px !important;
}

.NoteHeader-module__p-r-60___hV3C9 {
  padding-right: 60px !important;
}

.NoteHeader-module__m-b-1___azyi4 {
  margin-bottom: 1px !important;
}

.NoteHeader-module__m-b-2___jaHOG {
  margin-bottom: 2px !important;
}

.NoteHeader-module__m-b-6___FzeG5 {
  margin-bottom: 6px !important;
}

.NoteHeader-module__m-b-8___THIeG {
  margin-bottom: 8px !important;
}

.NoteHeader-module__m-b-10___kNxLV {
  margin-bottom: 10px !important;
}

.NoteHeader-module__m-b-14___LaMqw {
  margin-bottom: 14px !important;
}

.NoteHeader-module__m-b-16___GI_LN {
  margin-bottom: 16px !important;
}

.NoteHeader-module__m-b-20___vUjJS {
  margin-bottom: 20px !important;
}

.NoteHeader-module__m-b-22___Hs5eh {
  margin-bottom: 22px !important;
}

.NoteHeader-module__m-b-24___VwLOk {
  margin-bottom: 24px !important;
}

.NoteHeader-module__m-b-30___ney79 {
  margin-bottom: 30px !important;
}

.NoteHeader-module__m-b-32___use91 {
  margin-bottom: 32px !important;
}

.NoteHeader-module__m-b-40___cWny8 {
  margin-bottom: 40px !important;
}

.NoteHeader-module__m-t-2___kUeFr {
  margin-top: 2px !important;
}

.NoteHeader-module__m-t-3___UmecB {
  margin-top: 3px !important;
}

.NoteHeader-module__m-t-4___LH6Lq {
  margin-top: 4px !important;
}

.NoteHeader-module__m-t-5___PDzbX {
  margin-top: 5px !important;
}

.NoteHeader-module__m-t-8___O2KgU {
  margin-top: 8px !important;
}

.NoteHeader-module__m-t-10___Ex9zP {
  margin-top: 10px !important;
}

.NoteHeader-module__m-t-15___FchRi {
  margin-top: 15px !important;
}

.NoteHeader-module__m-t-16___Gv2LZ {
  margin-top: 16px !important;
}

.NoteHeader-module__m-t-20___IqgZw {
  margin-top: 20px !important;
}

.NoteHeader-module__m-t-22___peOiu {
  margin-top: 22px !important;
}

.NoteHeader-module__m-t-30___CFRb_ {
  margin-top: 30px !important;
}

.NoteHeader-module__m-t-32___mDENF {
  margin-top: 32px !important;
}

.NoteHeader-module__m-l-auto___ODwXd {
  margin-left: auto !important;
}

.NoteHeader-module__m-l-4___lwxgw {
  margin-left: 4px !important;
}

.NoteHeader-module__m-l-5___mPbUk {
  margin-left: 5px !important;
}

.NoteHeader-module__m-l-6___Rf3t5 {
  margin-left: 6px !important;
}

.NoteHeader-module__m-l-8____3svd {
  margin-left: 8px !important;
}

.NoteHeader-module__m-l-10___vktPu {
  margin-left: 10px !important;
}

.NoteHeader-module__m-l-16___HfxZ_ {
  margin-left: 16px !important;
}

.NoteHeader-module__m-l-20___S7G3R {
  margin-left: 20px !important;
}

.NoteHeader-module__m-l-24___dUMV3 {
  margin-left: 24px !important;
}

.NoteHeader-module__m-l-30___nuE7c {
  margin-left: 30px !important;
}

.NoteHeader-module__m-l-35___ouNMs {
  margin-left: 35px !important;
}

.NoteHeader-module__m-l-40___t2ova {
  margin-left: 40px !important;
}

.NoteHeader-module__m-r-8___Rvqnp {
  margin-right: 8px !important;
}

.NoteHeader-module__m-r-10___yeqQH {
  margin-right: 10px !important;
}

.NoteHeader-module__m-r-16___sc34h {
  margin-right: 16px !important;
}

.NoteHeader-module__m-r-20___ENmdI {
  margin-right: 20px !important;
}

.NoteHeader-module__m-r-24___QPlX_ {
  margin-right: 24px !important;
}

.NoteHeader-module__m-r-30___mLhN4 {
  margin-right: 30px !important;
}

.NoteHeader-module__m-r-40___N2Pfl {
  margin-right: 40px !important;
}

.NoteHeader-module__border-r-3___oLJw2 {
  border-radius: 3px !important;
}

.NoteHeader-module__border-r-4___eBqvN {
  border-radius: 4px !important;
}

.NoteHeader-module__border-r-6___p69Iz {
  border-radius: 6px !important;
}

.NoteHeader-module__border-r-10___MQefh {
  border-radius: 10px !important;
}

.NoteHeader-module__border-r-12___VZO7Q {
  border-radius: 12px !important;
}

.NoteHeader-module__border-r-16___mgkMt {
  border-radius: 16px !important;
}

.NoteHeader-module__border-r-50___pA4Ld {
  border-radius: 50% !important;
}

.NoteHeader-module__primary-border___eoIck {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteHeader-module__primary-border-b___fuG5C {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteHeader-module__primary-border-t___knc6d {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteHeader-module__primary-border-l___VxrTm {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteHeader-module__primary-border-r___McmKw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteHeader-module__secondary-border___qctIH {
  border: 1px solid #637768;
}

.NoteHeader-module__secondary-border-b___KwuL3 {
  border-bottom: 1px solid #637768;
}

.NoteHeader-module__secondary-border-t___EmgGd {
  border-top: 1px solid #637768;
}

.NoteHeader-module__secondary-border-l___sCxzt {
  border-left: 1px solid #637768;
}

.NoteHeader-module__secondary-border-r___P8UHL {
  border-right: 1px solid #637768;
}

.NoteHeader-module__gap-0___kmSiY {
  gap: 0 !important;
}

.NoteHeader-module__gap-2___Ju1BO {
  gap: 2px !important;
}

.NoteHeader-module__gap-4___uQmg8 {
  gap: 4px !important;
}

.NoteHeader-module__gap-5___ZLzKt {
  gap: 5px !important;
}

.NoteHeader-module__gap-6___bQlRw {
  gap: 6px !important;
}

.NoteHeader-module__gap-8___tdT3k {
  gap: 8px !important;
}

.NoteHeader-module__gap-10___u6oJs {
  gap: 10px !important;
}

.NoteHeader-module__gap-12___CO0AR {
  gap: 12px !important;
}

.NoteHeader-module__gap-14___ez130 {
  gap: 14px !important;
}

.NoteHeader-module__gap-16___k_PWY {
  gap: 16px !important;
}

.NoteHeader-module__gap-18___vbkc4 {
  gap: 18px !important;
}

.NoteHeader-module__gap-20___gNVv1 {
  gap: 20px !important;
}

.NoteHeader-module__gap-24___clKVw {
  gap: 24px !important;
}

.NoteHeader-module__gap-26___OgMHk {
  gap: 26px !important;
}

.NoteHeader-module__gap-30___ck8hN {
  gap: 30px !important;
}

.NoteHeader-module__gap-32___f7tpW {
  gap: 32px !important;
}

.NoteHeader-module__gap-40___JtHB9 {
  gap: 40px !important;
}

.NoteHeader-module__gap-50___sPeG7 {
  gap: 50px !important;
}

.NoteHeader-module__flex-1___MrCIm {
  flex: 1;
}

.NoteHeader-module__flex-none___rxPUw {
  flex: none !important;
}

.NoteHeader-module__flex-column___d7jMn {
  display: flex;
  flex-direction: column !important;
}

.NoteHeader-module__flex-row___MDXA2 {
  display: flex;
  flex-direction: row !important;
}

.NoteHeader-module__vertically-centered___o0rCW {
  display: flex;
  align-items: center !important;
}

.NoteHeader-module__horizontally-centered___WBYlb {
  display: flex;
  justify-content: center !important;
}

.NoteHeader-module__horizontally-end___DSFxo {
  display: flex;
  justify-content: end !important;
}

.NoteHeader-module__vertically-start___tudEk {
  display: flex;
  align-items: start !important;
}

.NoteHeader-module__space-between___bVwDa {
  display: flex;
  justify-content: space-between !important;
}

.NoteHeader-module__flex-wrap___e_Fsc {
  flex-wrap: wrap !important;
}

.NoteHeader-module__height-100___x5Y0d {
  height: 100%;
}

.NoteHeader-module__width-50___oFZUF {
  width: 50% !important;
}

.NoteHeader-module__width-100___KO_5A {
  width: 100%;
}

.NoteHeader-module__cursor-pointer___ZEN51 {
  cursor: pointer;
}

.NoteHeader-module__cursor-not-allowed___UGaXH {
  cursor: not-allowed !important;
}

.NoteHeader-module__absolute-centered___GcS7L {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.NoteHeader-module__absolute___v2M8v {
  position: absolute;
}

.NoteHeader-module__relative___pbber {
  position: relative;
}

.NoteHeader-module__fixed____OD2x {
  position: fixed;
}

.NoteHeader-module__visible___RaJf4 {
  opacity: 1;
}

.NoteHeader-module__invisible___mxajx {
  opacity: 0;
}

.NoteHeader-module__col-90___kUhap {
  width: 90% !important;
}

.NoteHeader-module__col-auto___l9gA_ {
  width: auto !important;
}

.NoteHeader-module__medical-tabs___fmFBI {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.NoteHeader-module__medical-table-new___MF6MT {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoteHeader-module__medical-table-new___MF6MT:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoteHeader-module__medical-table-new___MF6MT::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoteHeader-module__medical-table-new___MF6MT::-webkit-scrollbar-track {
  display: none;
}
.NoteHeader-module__medical-table-new___MF6MT.NoteHeader-module__no-pagination___nPFqo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoteHeader-module__medical-table-new___MF6MT.NoteHeader-module__no-pagination___nPFqo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoteHeader-module__medical-table-new___MF6MT.NoteHeader-module__no-pagination___nPFqo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoteHeader-module__medical-table-new___MF6MT.NoteHeader-module__no-pagination___nPFqo::-webkit-scrollbar-track {
  display: none;
}

.NoteHeader-module__medical-table-empty___Ui9qd {
  padding: 14px 40px !important;
}

.NoteHeader-module__icon-btn___XeSZ3 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.NoteHeader-module__search-icon___aG4am {
  width: 24px;
  height: 24px;
  align-self: center;
}

.NoteHeader-module__disable-select___NWpvV {
  user-select: none;
}

.NoteHeader-module__break-word___X2D21 {
  word-break: break-word;
}

.NoteHeader-module__popup-clear-btn___ep31b {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.NoteHeader-module__scroll-m-b-20___xkEt0 {
  scroll-margin-bottom: 20px;
}

.NoteHeader-module__header___V6Pya {
  display: flex;
  flex-direction: row;
  background-color: #f1f3e7;
  padding: 11px 30px;
  align-items: center;
}
.NoteHeader-module__header___V6Pya .NoteHeader-module__textContainer___IbN0t {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.NoteHeader-module__header___V6Pya .NoteHeader-module__textContainer___IbN0t .NoteHeader-module__title___jZzJK {
  color: #375844;
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.18px;
}
.NoteHeader-module__header___V6Pya .NoteHeader-module__textContainer___IbN0t .NoteHeader-module__subtitle___EsXDF {
  color: #375844;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;
}
.NoteHeader-module__header___V6Pya .NoteHeader-module__textContainer___IbN0t .NoteHeader-module__timeProvider___bC9e8 {
  color: #859989;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.12px;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/NoteHeader/NoteHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;AA8pBJ;AA5pBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA8pBN;AA3pBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA6pBN;AA1pBI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA4pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  display: flex;\n  flex-direction: row;\n  background-color: get-color(greenNew, lighter);\n  padding: 11px 30px;\n  align-items: center;\n\n  .textContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    .title {\n      color: get-color(greenNew, dark);\n      font-size: 18px;\n      font-weight: 700;\n      line-height: normal;\n      letter-spacing: -0.18px;\n    }\n\n    .subtitle {\n      color: get-color(greenNew, dark);\n      font-size: 16px;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: -0.16px;\n    }\n\n    .timeProvider {\n      color: get-color(greenNew, medium);\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      letter-spacing: -0.12px;\n      margin-top: 5px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `NoteHeader-module__font-s-10___Q2f81`,
	"fontS12": `NoteHeader-module__font-s-12___nMwLI`,
	"fontS13": `NoteHeader-module__font-s-13____LqSY`,
	"fontS14": `NoteHeader-module__font-s-14___Po4ji`,
	"fontS15": `NoteHeader-module__font-s-15___BGNUA`,
	"fontS16": `NoteHeader-module__font-s-16___hEJhj`,
	"fontS18": `NoteHeader-module__font-s-18___pbZIF`,
	"fontS20": `NoteHeader-module__font-s-20___KIPW5`,
	"fontS22": `NoteHeader-module__font-s-22___FKJb1`,
	"fontS28": `NoteHeader-module__font-s-28___er8Fr`,
	"fontW400": `NoteHeader-module__font-w-400___rJvxe`,
	"fontW500": `NoteHeader-module__font-w-500___ZzzgL`,
	"fontW600": `NoteHeader-module__font-w-600___gfcIL`,
	"fontW700": `NoteHeader-module__font-w-700___JQuy1`,
	"p5": `NoteHeader-module__p-5___dU2JU`,
	"p12": `NoteHeader-module__p-12___kkcf7`,
	"p16": `NoteHeader-module__p-16___lyAE0`,
	"p30": `NoteHeader-module__p-30___zBkDL`,
	"pB0": `NoteHeader-module__p-b-0___tK3FL`,
	"pB5": `NoteHeader-module__p-b-5____r90j`,
	"pB10": `NoteHeader-module__p-b-10___z4wXU`,
	"pB12": `NoteHeader-module__p-b-12___WytX4`,
	"pB16": `NoteHeader-module__p-b-16___tb6sv`,
	"pB18": `NoteHeader-module__p-b-18___dUHsf`,
	"pB20": `NoteHeader-module__p-b-20___NiuQG`,
	"pB25": `NoteHeader-module__p-b-25___l754P`,
	"pB30": `NoteHeader-module__p-b-30___bHJ1i`,
	"pB50": `NoteHeader-module__p-b-50___o0Dov`,
	"pT0": `NoteHeader-module__p-t-0___vDlg8`,
	"pT12": `NoteHeader-module__p-t-12___cULVN`,
	"pT16": `NoteHeader-module__p-t-16___mg36f`,
	"pT18": `NoteHeader-module__p-t-18___GakpD`,
	"pT20": `NoteHeader-module__p-t-20___Whfx0`,
	"pT30": `NoteHeader-module__p-t-30___EfEij`,
	"pT40": `NoteHeader-module__p-t-40___G8D8G`,
	"pT50": `NoteHeader-module__p-t-50___PHg1P`,
	"pL20": `NoteHeader-module__p-l-20___QHYJ4`,
	"pL30": `NoteHeader-module__p-l-30___ij2sJ`,
	"pL40": `NoteHeader-module__p-l-40___da_Pl`,
	"pR16": `NoteHeader-module__p-r-16___HHMQ8`,
	"pR20": `NoteHeader-module__p-r-20___vBFAL`,
	"pR30": `NoteHeader-module__p-r-30___ZguBy`,
	"pR50": `NoteHeader-module__p-r-50___FLua3`,
	"pR60": `NoteHeader-module__p-r-60___hV3C9`,
	"mB1": `NoteHeader-module__m-b-1___azyi4`,
	"mB2": `NoteHeader-module__m-b-2___jaHOG`,
	"mB6": `NoteHeader-module__m-b-6___FzeG5`,
	"mB8": `NoteHeader-module__m-b-8___THIeG`,
	"mB10": `NoteHeader-module__m-b-10___kNxLV`,
	"mB14": `NoteHeader-module__m-b-14___LaMqw`,
	"mB16": `NoteHeader-module__m-b-16___GI_LN`,
	"mB20": `NoteHeader-module__m-b-20___vUjJS`,
	"mB22": `NoteHeader-module__m-b-22___Hs5eh`,
	"mB24": `NoteHeader-module__m-b-24___VwLOk`,
	"mB30": `NoteHeader-module__m-b-30___ney79`,
	"mB32": `NoteHeader-module__m-b-32___use91`,
	"mB40": `NoteHeader-module__m-b-40___cWny8`,
	"mT2": `NoteHeader-module__m-t-2___kUeFr`,
	"mT3": `NoteHeader-module__m-t-3___UmecB`,
	"mT4": `NoteHeader-module__m-t-4___LH6Lq`,
	"mT5": `NoteHeader-module__m-t-5___PDzbX`,
	"mT8": `NoteHeader-module__m-t-8___O2KgU`,
	"mT10": `NoteHeader-module__m-t-10___Ex9zP`,
	"mT15": `NoteHeader-module__m-t-15___FchRi`,
	"mT16": `NoteHeader-module__m-t-16___Gv2LZ`,
	"mT20": `NoteHeader-module__m-t-20___IqgZw`,
	"mT22": `NoteHeader-module__m-t-22___peOiu`,
	"mT30": `NoteHeader-module__m-t-30___CFRb_`,
	"mT32": `NoteHeader-module__m-t-32___mDENF`,
	"mLAuto": `NoteHeader-module__m-l-auto___ODwXd`,
	"mL4": `NoteHeader-module__m-l-4___lwxgw`,
	"mL5": `NoteHeader-module__m-l-5___mPbUk`,
	"mL6": `NoteHeader-module__m-l-6___Rf3t5`,
	"mL8": `NoteHeader-module__m-l-8____3svd`,
	"mL10": `NoteHeader-module__m-l-10___vktPu`,
	"mL16": `NoteHeader-module__m-l-16___HfxZ_`,
	"mL20": `NoteHeader-module__m-l-20___S7G3R`,
	"mL24": `NoteHeader-module__m-l-24___dUMV3`,
	"mL30": `NoteHeader-module__m-l-30___nuE7c`,
	"mL35": `NoteHeader-module__m-l-35___ouNMs`,
	"mL40": `NoteHeader-module__m-l-40___t2ova`,
	"mR8": `NoteHeader-module__m-r-8___Rvqnp`,
	"mR10": `NoteHeader-module__m-r-10___yeqQH`,
	"mR16": `NoteHeader-module__m-r-16___sc34h`,
	"mR20": `NoteHeader-module__m-r-20___ENmdI`,
	"mR24": `NoteHeader-module__m-r-24___QPlX_`,
	"mR30": `NoteHeader-module__m-r-30___mLhN4`,
	"mR40": `NoteHeader-module__m-r-40___N2Pfl`,
	"borderR3": `NoteHeader-module__border-r-3___oLJw2`,
	"borderR4": `NoteHeader-module__border-r-4___eBqvN`,
	"borderR6": `NoteHeader-module__border-r-6___p69Iz`,
	"borderR10": `NoteHeader-module__border-r-10___MQefh`,
	"borderR12": `NoteHeader-module__border-r-12___VZO7Q`,
	"borderR16": `NoteHeader-module__border-r-16___mgkMt`,
	"borderR50": `NoteHeader-module__border-r-50___pA4Ld`,
	"primaryBorder": `NoteHeader-module__primary-border___eoIck`,
	"primaryBorderB": `NoteHeader-module__primary-border-b___fuG5C`,
	"primaryBorderT": `NoteHeader-module__primary-border-t___knc6d`,
	"primaryBorderL": `NoteHeader-module__primary-border-l___VxrTm`,
	"primaryBorderR": `NoteHeader-module__primary-border-r___McmKw`,
	"secondaryBorder": `NoteHeader-module__secondary-border___qctIH`,
	"secondaryBorderB": `NoteHeader-module__secondary-border-b___KwuL3`,
	"secondaryBorderT": `NoteHeader-module__secondary-border-t___EmgGd`,
	"secondaryBorderL": `NoteHeader-module__secondary-border-l___sCxzt`,
	"secondaryBorderR": `NoteHeader-module__secondary-border-r___P8UHL`,
	"gap0": `NoteHeader-module__gap-0___kmSiY`,
	"gap2": `NoteHeader-module__gap-2___Ju1BO`,
	"gap4": `NoteHeader-module__gap-4___uQmg8`,
	"gap5": `NoteHeader-module__gap-5___ZLzKt`,
	"gap6": `NoteHeader-module__gap-6___bQlRw`,
	"gap8": `NoteHeader-module__gap-8___tdT3k`,
	"gap10": `NoteHeader-module__gap-10___u6oJs`,
	"gap12": `NoteHeader-module__gap-12___CO0AR`,
	"gap14": `NoteHeader-module__gap-14___ez130`,
	"gap16": `NoteHeader-module__gap-16___k_PWY`,
	"gap18": `NoteHeader-module__gap-18___vbkc4`,
	"gap20": `NoteHeader-module__gap-20___gNVv1`,
	"gap24": `NoteHeader-module__gap-24___clKVw`,
	"gap26": `NoteHeader-module__gap-26___OgMHk`,
	"gap30": `NoteHeader-module__gap-30___ck8hN`,
	"gap32": `NoteHeader-module__gap-32___f7tpW`,
	"gap40": `NoteHeader-module__gap-40___JtHB9`,
	"gap50": `NoteHeader-module__gap-50___sPeG7`,
	"flex1": `NoteHeader-module__flex-1___MrCIm`,
	"flexNone": `NoteHeader-module__flex-none___rxPUw`,
	"flexColumn": `NoteHeader-module__flex-column___d7jMn`,
	"flexRow": `NoteHeader-module__flex-row___MDXA2`,
	"verticallyCentered": `NoteHeader-module__vertically-centered___o0rCW`,
	"horizontallyCentered": `NoteHeader-module__horizontally-centered___WBYlb`,
	"horizontallyEnd": `NoteHeader-module__horizontally-end___DSFxo`,
	"verticallyStart": `NoteHeader-module__vertically-start___tudEk`,
	"spaceBetween": `NoteHeader-module__space-between___bVwDa`,
	"flexWrap": `NoteHeader-module__flex-wrap___e_Fsc`,
	"height100": `NoteHeader-module__height-100___x5Y0d`,
	"width50": `NoteHeader-module__width-50___oFZUF`,
	"width100": `NoteHeader-module__width-100___KO_5A`,
	"cursorPointer": `NoteHeader-module__cursor-pointer___ZEN51`,
	"cursorNotAllowed": `NoteHeader-module__cursor-not-allowed___UGaXH`,
	"absoluteCentered": `NoteHeader-module__absolute-centered___GcS7L`,
	"absolute": `NoteHeader-module__absolute___v2M8v`,
	"relative": `NoteHeader-module__relative___pbber`,
	"fixed": `NoteHeader-module__fixed____OD2x`,
	"visible": `NoteHeader-module__visible___RaJf4`,
	"invisible": `NoteHeader-module__invisible___mxajx`,
	"col90": `NoteHeader-module__col-90___kUhap`,
	"colAuto": `NoteHeader-module__col-auto___l9gA_`,
	"medicalTabs": `NoteHeader-module__medical-tabs___fmFBI`,
	"medicalTableNew": `NoteHeader-module__medical-table-new___MF6MT`,
	"noPagination": `NoteHeader-module__no-pagination___nPFqo`,
	"medicalTableEmpty": `NoteHeader-module__medical-table-empty___Ui9qd`,
	"iconBtn": `NoteHeader-module__icon-btn___XeSZ3`,
	"searchIcon": `NoteHeader-module__search-icon___aG4am`,
	"disableSelect": `NoteHeader-module__disable-select___NWpvV`,
	"breakWord": `NoteHeader-module__break-word___X2D21`,
	"popupClearBtn": `NoteHeader-module__popup-clear-btn___ep31b`,
	"scrollMB20": `NoteHeader-module__scroll-m-b-20___xkEt0`,
	"header": `NoteHeader-module__header___V6Pya`,
	"textContainer": `NoteHeader-module__textContainer___IbN0t`,
	"title": `NoteHeader-module__title___jZzJK`,
	"subtitle": `NoteHeader-module__subtitle___EsXDF`,
	"timeProvider": `NoteHeader-module__timeProvider___bC9e8`
};
module.exports = ___CSS_LOADER_EXPORT___;
